import React from 'react';
import NewsletterForm from './NewsletterForm';
import NavPromoCard from './NavPromoCard';
import { logNavInteraction, NAV_LOCATIONS, NAV_ELEMENT_TYPES, NAV_ACTIONS } from 'utils';

const BASE_NAV_INTERACTION_CONFIG = {
  location: NAV_LOCATIONS.PRIMARY, 
  depth: 1, 
}

const DropdownMenuItem = React.forwardRef(({ isOpen, onClose, promoData, featuredProducts, displayNewsletter, categoryGroups, featuredLinks, numberOfColumns, featuredProductsNavSectionName, newsletterNavSectionName, featuredLinksNavSectionName, dropdownContentNavSectionName, featuredPromoCardsNavSectionName}, ref) => {

  const onDropdownContentClick = function(navInteractionConfig) {    
    onClose();

    logNavInteraction({
      ...BASE_NAV_INTERACTION_CONFIG,
      ...navInteractionConfig,
    });
  }

  let dropdownContentOrderCounter = 0;


  //Get live content
  const livePromoCards = promoData
  ? promoData?.filter(card => card.isLive) || []
  : [];

  const liveFeaturedProducts = featuredProducts ? featuredProducts.filter(product => product.isLive) : [];

  numberOfColumns = displayNewsletter ? 3 : numberOfColumns;

  const liveFeaturedLinks = featuredLinks ? featuredLinks.filter(link => link.isLive) : [];

  return (
    <div
      ref={ref}
      role="menu"
      aria-orientation="vertical"
      aria-hidden={!isOpen} 
      onClick={(e) => e.stopPropagation()}  
      className="tw-absolute tw-left-0 tw-top-full tw-flex tw-w-full tw-justify-center tw-overflow-hidden tw-bg-white tw-py-24 tw-shadow-[0px_6px_15px_-2px_rgba(16,24,40,0.08)]"
      style={{
        transform: isOpen ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 0.5s ease, opacity 0.5s ease',
        visibility: isOpen ? 'visible' : 'hidden',
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? 'auto' : 'none',
        zIndex: isOpen ? 1 : -1,
      }}
    >
      <div className={`cirk-container tw-flex tw-gap-20 ${displayNewsletter ? 'tw-justify-between' : 'tw-justify-center'} tw-px-20`}>
      {liveFeaturedLinks.length > 0 && (
          <ul className='tw-ml-0 tw-flex tw-w-[15%] tw-flex-col tw-items-end'>
            {liveFeaturedLinks.map((featuredLink, index) => (
              <li key={index} className='tw-w-full tw-py-8' onClick={onClose}>
                <a
                  className="tw-block tw-w-full tw-px-12 tw-py-8 tw-text-14 tw-font-semibold tw-leading-16 hover:tw-text-[#00A3E0]" 
                  href={featuredLink.link}     
                  onClick={() => logNavInteraction({
                    ...BASE_NAV_INTERACTION_CONFIG,
                    section: featuredLinksNavSectionName, 
                    order: index + 1, 
                    elementType: NAV_ELEMENT_TYPES.TEXT, 
                    text: featuredLink.label, 
                    action: NAV_ACTIONS.LINK,
                  })}      
                >
                  {featuredLink.label.includes('®') ? (
                    <>
                      {featuredLink.label.split('®')[0]}
                      <sup className="tw-top-[-.3em]">®</sup>
                      {featuredLink.label.split('®')[1]}
                    </>
                  ) : (
                      <span
                      className={featuredLink.label === 'Hot Deals' ? '!tw-text-[#EF2828]' : ''}
                    >
                      {featuredLink.label}
                    </span>
                  )}
                </a>
              </li>
            ))}
          </ul>
        )}

        <div 
          className={`tw-grid tw-gap-20 ${categoryGroups.length > 0 ? 'tw-w-[51.5%] tw-grid-rows-2' : ''}`}
          style={{ gridTemplateColumns: numberOfColumns ? `repeat(${numberOfColumns}, 1fr)` : 'repeat(3, 1fr)' }}
        >
          {/* Featured Products Section */}
          {liveFeaturedProducts?.map((item, index) => (
            <div key={index} className="tw-flex tw-w-full tw-max-w-[234px] tw-flex-col tw-gap-2">
              <a href={item.link} onClick={() => logNavInteraction({
                ...BASE_NAV_INTERACTION_CONFIG,
                section: featuredProductsNavSectionName, 
                order: index + 1,
                elementType: NAV_ELEMENT_TYPES.IMAGE,
                text: item.label, 
                action: NAV_ACTIONS.LINK,
              })}>
                <div className="tw-relative tw-overflow-hidden tw-rounded-8">
                  <img
                    className="
                      tw-aspect-square 
                      tw-h-auto 
                      tw-w-full 
                      tw-rounded-8 
                      tw-object-cover 
                      tw-transition-transform 
                      tw-duration-300 
                      tw-ease-in-out 
                      tw-will-change-transform 
                      hover:tw-scale-[1.07]
                    "
                    src={item.desktopImage}
                    alt={item.imageAlt}
                    loading="lazy"
                  />
                </div>
                <div className='tw-mt-8 tw-flex tw-items-center tw-justify-between'>
                  <div className="tw-text-16 tw-font-bold tw-leading-18 tw-text-gray">
                    {item.label.includes('®') ? (
                      <>
                        {item.label.split('®')[0]}
                        <sup className="tw-top-[-0.25em]">®</sup>
                        {item.label.split('®')[1]}
                      </>
                    ) : (
                      item.label
                    )}
                    
                  {item.isNew && !item.customLabel && (
                    <sup className="cirk-paragraph-xsmall tw--top-[0.15rem] tw-ml-8 tw-font-semibold tw-leading-[14px] tw-text-[#00A3E0]">
                      *New*
                    </sup>
                  )}
                  {item.customLabel && (
                    <sup className="cirk-paragraph-xsmall tw--top-[0.15rem] tw-ml-8 tw-font-semibold tw-leading-[14px] tw-text-[#00A3E0]">
                      {item.customLabel}
                    </sup>
                  )}

                  </div>
                </div>
                <div className="tw-mt-6 tw-text-14 tw-text-[#6B7280]">{item.textContent}</div>
                {item.disclaimer && (
                  <span className="tw-text-12 tw-text-[#00A3E0]">{item.disclaimer}</span>
                )}
              </a>
            </div>
          ))}

          {/* Dropdown Content Section */}
          {categoryGroups?.map((item) => {
            const dropdownContentItemOrder = ++dropdownContentOrderCounter;
            return <React.Fragment key={item.id}>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <a
                  className={item.link ? "tw-group" : ""}
                  href={item.link}
                  {...(item.link && {
                    onClick: () => onDropdownContentClick({
                      section: dropdownContentNavSectionName, 
                      order: dropdownContentItemOrder, 
                      elementType: NAV_ELEMENT_TYPES.IMAGE, 
                      text: item.label, 
                      action: NAV_ACTIONS.LINK,
                    })
                 })}>
                  <img 
                    className={`${numberOfColumns == 3 ? 'tw-aspect-[9/4]' : 'tw-aspect-[1.7378]'} tw-h-auto tw-w-full tw-rounded-[.5rem] tw-object-cover`}
                    src={item.image} 
                    alt={item.alt} 
                  />
                  <div className='tw-mt-8 tw-flex tw-items-center tw-justify-between'>
                    <div className="tw-text-14 tw-font-bold tw-leading-16 tw-text-[#3F4443] group-hover:tw-text-[#00A3E0]" {...(item.link ? { onClick: onClose } : {})}>
                      {item.label.includes('®') ? (
                        <>
                          {item.label.split('®')[0]}
                          <sup className="tw-top-[-.25em] tw-text-[65%]">®&nbsp;</sup>
                          {item.label.split('®')[1]}
                        </>
                      ) : (
                        item.label
                      )}
                      {item.isNew && (
                        <sup className="cirk-paragraph-xsmall tw--top-[0.15rem] tw-ml-8 tw-font-semibold tw-leading-[14px] tw-text-[#00A3E0]">
                          *New*
                        </sup>
                      )}
                    </div>
                  </div>
                  <div className="tw-mt-6 tw-text-14 tw-text-[#6B7280]">{item.description}</div>
                </a>
                {item.subLinks && (
                  <ul className='tw-ml-0'>
                    {item.subLinks.map((subLink, subIndex) => {
                      const dropdownContentSubItemOrder = ++dropdownContentOrderCounter;
                      return <li key={subIndex}>
                        <a 
                          href={subLink.link} 
                          className='tw-box-content tw-inline-flex tw-w-full tw-items-center tw-py-6 tw-text-14 tw-leading-16 hover:tw-text-[#00A3E0]'
                          onClick={() => onDropdownContentClick({
                            section: dropdownContentNavSectionName, 
                            order: dropdownContentSubItemOrder, 
                            elementType: NAV_ELEMENT_TYPES.TEXT, 
                            text: subLink.label, 
                            action: NAV_ACTIONS.LINK,
                          })}
                        >
                          {subLink.label.includes('®') ? (
                            <>
                              {subLink.label.split('®')[0]}
                              <sup className="tw-top-[-.25em] tw-text-[65%]">®&nbsp;</sup>
                              {subLink.label.split('®')[1]}
                            </>
                          ) : (
                            subLink.label
                          )}
                        </a>
                      </li> 
                    })}
                  </ul>
                )}
              </div>
            </React.Fragment>
          })}
        </div>

        {displayNewsletter && liveFeaturedProducts.length < 4 && (
          <div className='tw-flex tw-w-[33.5%] tw-flex-col tw-justify-center'>
            <NewsletterForm signupFormLocation={'Nav Mega Menu'} navInteractionConfig={{ 
              ...BASE_NAV_INTERACTION_CONFIG,
              section: newsletterNavSectionName, 
            }} />         
          </div>
        )}

        

        {livePromoCards.length > 0 && (
          <div className='tw-flex tw-w-[33.5%] tw-flex-col tw-gap-20'>
            {livePromoCards.slice(0, 2).map((featuredPromoCard, index) => (
              <NavPromoCard 
                key={index}
                image={featuredPromoCard.image}
                label={featuredPromoCard.title}
                link={featuredPromoCard.link}
                gradient={featuredPromoCard.gradient || 'linear-gradient(0deg, rgba(5, 38, 49, 0) 60.69%, rgba(5, 38, 49, 0.48) 74.38%, rgba(5, 38, 49, 0.8) 91.59%)'}
                closeMenu={onClose}
                navInteractionConfig={{ 
                  ...BASE_NAV_INTERACTION_CONFIG,
                  section: featuredPromoCardsNavSectionName, 
                  order: index + 1,
                }}
              />
            ))}

            {/* Optional: show 1 placeholder if only one live promo exists */}
            {livePromoCards.length === 1 && <NavPromoCard placeholder />}
          </div>
        )}

      </div>
    </div>
  );
});

export default DropdownMenuItem;